import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LoadingContextProvider } from "./context/LoadingContext";

import "bootstrap/dist/css/bootstrap.min.css";

import "./style/index.css";

import "./interceptors/axios";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ptBR from "date-fns/locale/pt-BR";
import { QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { queryClient } from "shared/util/queryClient";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
        <LoadingContextProvider>
          {/* <PermissoesContextProvider> */}
          <App />
          {/* </PermissoesContextProvider> */}
        </LoadingContextProvider>
      </MuiPickersUtilsProvider>
      {process.env.REACT_APP_PROFILE === "development" && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
);
